import axios from "axios"
import { auth } from "../auth/auth"

const LOCALHOST_API = process.env.REACT_APP_LOCALHOST_API_BASE

const api = axios.create({
  baseURL: LOCALHOST_API,
})

api.interceptors.request.use((config) => {
  const token = auth.getToken()

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export default api
